import { useLocationsSetupIntentRetrieve, useStafferOrganizationsSetupIntentRetrieve } from "@sidegigllc/api/client";
import type { PaymentSourceId } from "./useSaveStripePaymentMethod";
import { useStripeStyles } from "./useStripeStyles";

export const useStripePaymentMethodUpdateContainer = ({ sourceId }: { sourceId: PaymentSourceId }) => {
  const stripeStyles = useStripeStyles();

  const isOrganization = "organizationId" in sourceId;
  const isLocation = "locationId" in sourceId;
  const {
    data: orgClientSecret,
    isLoading: orgLoading,
    isError: orgError,
  } = useStafferOrganizationsSetupIntentRetrieve(isOrganization ? sourceId.organizationId : "", {
    query: { enabled: isOrganization },
  });
  const {
    data: locationClientSecret,
    isLoading: locationLoading,
    isError: locationError,
  } = useLocationsSetupIntentRetrieve(isLocation ? (sourceId?.locationId ?? 0) : 0, { query: { enabled: isLocation } });

  const clientSecret = isLocation ? locationClientSecret?.client_secret : orgClientSecret?.client_secret;
  const isLoading = !clientSecret || (isLocation ? locationLoading : orgLoading);
  return {
    isLoading,
    isError: isLocation ? locationError : orgError,
    clientSecret,
    stripeStyles,
  };
};
